import { mediacoreApi } from '@apis/mediacoreApi'
import { createOneMutation, deleteByIdMutation, getByIdQuery, updateByIdMutation } from '@apis/mediacoreQueries'
import { Client } from '@types'

const clientsURL = 'core/clientes'

const clientsApi = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientById: builder.query<Client, { id: number }>({
      query: getByIdQuery(clientsURL),
      providesTags: (_result, _error, { id }) => [{ type: 'Client', id }],
    }),
    deleteClient: builder.mutation<void, { id: number }>({
      query: deleteByIdMutation(clientsURL),
      invalidatesTags: ['ClientTable'],
    }),
    createClient: builder.mutation<Client, { data: Partial<Client> }>({
      query: createOneMutation(clientsURL),
      invalidatesTags: ['ClientTable'],
    }),
    updateClient: builder.mutation<Client, { id: number; data: Partial<Client> }>({
      query: updateByIdMutation(clientsURL),
      invalidatesTags: ['ClientTable'],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedClient } = await queryFulfilled
          dispatch(
            clientsApi.util.updateQueryData('getClientById', { id }, (draft) => {
              Object.assign(draft, updatedClient)
            }),
          )
        } catch {}
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetClientByIdQuery,
  useDeleteClientMutation,
  useCreateClientMutation,
  useUpdateClientMutation,
  usePrefetch: usePrefetchClients,
} = clientsApi
